/// <reference types="@angular/localize" />

import { HttpClient } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { initializeMsalInstance } from './app/utility/authentication/msal.util';

export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}

async function bootstrap() {
  await initializeMsalInstance();
  bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
}

bootstrap();
